// Pin Luxon's ambient default zone to UTC for every roo-time consumer.
//
// WHY: RooDateTime is a Luxon `DateTime` proxy, and `DateTime.fromMillis(ms)`
// (or `fromISO`/`fromJSDate`) with no explicit zone resolves in the host's
// `process.env.TZ`. Without this pin, every RooDateTime computation silently
// depends on WHERE the code runs — a laptop, a UTC devpod, a CI pod, prod. That
// divergence skewed the CI Android emulator clock ~6h and broke
// cardSorterDragLiving (ADR: utc-only-runtimes). Prod is already UTC; this makes the process
// TZ irrelevant for RooDateTime everywhere, so results are identical regardless
// of host.
//
// Timezone is ALWAYS passed explicitly (a user's `communication_timezone`) via
// `.setZone(...)` where local-time semantics are needed — never inherited from
// the ambient process. See libraries/roo-time/CLAUDE.md.
//
// Note: this governs the Luxon (RooDateTime) surface only. `RooDate extends
// Date` is native and its `.getHours()/.getDate()/...` read the OS/process
// zone regardless of any Luxon setting — those are made deterministic by the
// runtime being UTC (`TZ=Etc/UTC` in the devpod/CI images), not by this file.
//
// `Settings` (unlike `DateTime`) is not covered by the eslint luxon import
// restriction, so no eslint-disable is needed here.
import { Settings } from "luxon";
/**
 * Idempotently pin Luxon's default zone to UTC. Runs automatically on module
 * load (below) so merely importing `roo-time` is enough; also exported so an
 * entrypoint can assert the invariant defensively.
 */
export function ensureUtcDefaultZone() {
    Settings.defaultZone = "utc";
}
// Module-load side effect: any import of roo-time (RooDate / RooDateTime /
// index) pins the zone before the first date is constructed.
ensureUtcDefaultZone();
//# sourceMappingURL=defaultZone.js.map